import MuiChip, { ChipProps } from '@mui/material/Chip';
import React from 'react';

export type { ChipProps };

export const Chip = React.forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  const { color = 'primary', variant = 'outlined', ...restProps } = props;

  return <MuiChip {...restProps} variant={variant} color={color} ref={ref} />;
});
